var PaymentServiceValidationCompat = (function ($, _, Backbone, PaymentService) {
	// Needed because some client code can use isValid() or checkValid() on payment service.
	var PaymentServiceValidationCompat = PaymentService.extend({
		initialize: function (attrs, opts) {
			PaymentService.prototype.initialize.apply(this, arguments);

			this._validator = opts.Validator;
		},

		isValid: function (opts) {
			if (this._validator) {
				return this._validator.isValid(opts);
			} else {
				return { result: true }
			}
		},

		checkValid: function (opts) {
			if (this._validator) {
				return this._validator.validate(opts);
			} else {
				return { result: true }
			}
		}
	});

	return PaymentServiceValidationCompat;
})($, _, Backbone, PaymentService);
